import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import SEOSection from './components/SEOSection';
import ArticleCards from './components/ArticleCards';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'GTBuy Spreadsheet',
            url: 'https://gtbuy.team',
            description: 'Smart Shopping Agent Comparison Tool 2026 — Compare prices, shipping, and trust scores across GTBuy, Kakobuy, Superbuy and more. Find the cheapest agent for sneakers, fashion, electronics and accessories.',
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: 'https://gtbuy.team/search?q={search_term_string}',
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <SEOSection />
        <ArticleCards />
      </main>
      <Footer />
    </div>
  );
}